// Energy breakdown table
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import StandardAnalysisPage from '@/features/energyxplorer/components/deepdive/StandardAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table',
)({
  component: StandardAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_tree_overview' },
});
